import { FirebaseApp } from 'firebase/app';
import { AccountStatusApiService } from './AccountStatus';
import { FundsApiService } from './FundsApi';
import { getFunctions } from 'firebase/functions';
import { UserAccountsApiService } from './UserAccounts';

class ApiFactory {
    accountStatusApi: AccountStatusApiService | undefined;
    fundsApiService: FundsApiService | undefined;
    userAccountsApi: UserAccountsApiService | undefined;

    constructor(firebaseApp?: FirebaseApp) {
      if (firebaseApp) {
        this.onFirebaseAppChange(firebaseApp);
      }
    }

    async onFirebaseAppChange(firebaseApp: FirebaseApp) {
      const functions = getFunctions(firebaseApp);

      this.accountStatusApi = new AccountStatusApiService(functions);
      this.fundsApiService = new FundsApiService(functions);
      this.userAccountsApi = new UserAccountsApiService(functions);
    }

    getAccountStatusApi() {
      return this.accountStatusApi;
    }

    getfundsApiService() {
      return this.fundsApiService;
    }

    getUserAccountsApi() {
      return this.userAccountsApi;
    }
};

export const ApiFactoryInstance = new ApiFactory();
